export const HTL_TYPEAHEAD_POPULAR_TRENDING_EXPERIMENT = 'HTL_TYPEHD_POPULAR_TRNDNG_SEARCH'

export function isHotelTypeaheadEndpoint(endpoint: string): boolean {
  return endpoint === 'hotels' || endpoint === 'hotelsV2'
}
